import { render, staticRenderFns } from "./IconButtonWithDropdown.vue?vue&type=template&id=55d7ba58&lang=pug&"
import script from "./IconButtonWithDropdown.vue?vue&type=script&lang=ts&"
export * from "./IconButtonWithDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports